import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { routes } from 'consts';
import {
  EnelXGuiAtoms,
} from 'gui';
import { useTheme } from 'styled-components';

import Sidebar from './Sidebar/Sidebar';
import UserSidebar from './UserSidebar/UserSidebar';
import NavbarWrapper from './style';

const { MigrationHeader, MigrationImage } = EnelXGuiAtoms;

const {
  MigrationButton,
} = EnelXGuiAtoms;

function Navbar() {
  const history = useHistory();
  const theme = useTheme();
  const { t } = useTranslation();

  const SLOTS = [
    {
      id: 'headerLogo',
      isVisible: true,
      element: () => (
        <MigrationImage
          source={theme.config[isMobileOnly ? 'mobileHeaderLogo' : 'headerLogo']}
          onClick={() => history.push(routes.dashboard.root)}
          style={{
            cursor: 'pointer',
            maxHeight: '100%',
          }}
        />
      ),
    },
    {
      id: 'applicationsButton',
      isVisible: false,
      element: () => (
        <MigrationButton
          onClick={() => window.open(process.env.MY_ENELX_URL, '_blank')}
          btnText={isMobileOnly ? null : t('myApplications')}
          iconRight
          iconName="application-group"
          iconSize="1.2em"
          btnType="secondary"
          btnShape="square"
          // eslint-disable-next-line react/style-prop-object
          style={isMobileOnly ? {} : { backgroundColor: 'transparent', color: 'white', borderColor: 'white' }}
        />
      ),
    },
    {
      id: 'loggedInAvatar',
      element: () => <UserSidebar />,
      isVisible: true,
    },
    {
      id: 'sandwichMenuButton',
      element: () => <Sidebar />,
      isVisible: true,
    },
  ].filter((slot) => slot?.isVisible);

  return (
    <NavbarWrapper>
      <MigrationHeader renderCustomContent={false}>
        {
          SLOTS.map(({
            id,
            element,
          }) => (
            <div slot={id} key={id}>
              {element()}
            </div>
          ))
        }
      </MigrationHeader>
    </NavbarWrapper>
  );
}

export default Navbar;
